import classes from './Vendor.module.css';

import LogoImage from './LogoImage.jsx';
import { ServicesSection } from '../pages/Services.jsx';

import { rows } from '../util/helpers.jsx';

function Vendor({vendor}) {

  const limit = 15;

  //console.log(`Vendor id: ${vendor.id} data: ${JSON.stringify(vendor)}`);
  //console.log(`Vendor id: ${vendor.id} services: ${vendor.services}`);

  return (
    <div className={classes.vendor}>
      <span>
        <LogoImage
          title={vendor.title}
          logo_contents={vendor.logo_contents}
          logo_filetype={vendor.logo_filetype}
          url={vendor.website}
        />
        <ul>
        <li><h2>{vendor.title}</h2></li>
        <li><a href={`tel:${vendor.phone}`}>{vendor.phone}</a></li>
        <li><a href={`mailto:${vendor.email}`}>{vendor.email}</a></li>
        <li><a href={vendor.website}>{vendor.website}</a></li>
        </ul>
      </span>
      <span>
        <h2>Services Summary</h2>
        <textarea
          id="services-summary"
          name="services-summary"
          rows={rows(vendor.services, limit)}
          cols={60}
          readonly
          value={vendor.services}
        />
        <ServicesSection id={vendor.id} />
      </span>
    </div>
  );
}

export default Vendor;
